import { styled } from '@linaria/react';
import { bodyFont, colors, fonts, layout, space } from '../../theme/tokens';

export const FilterPillGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${space[2]};
  justify-content: flex-start;
  width: 100%;

  @media (min-width: ${layout.desktopBreakpoint}) {
    justify-content: flex-end;
    width: auto;
    margin-left: auto;
  }
`;

export const FilterPill = styled.button<{ $active?: boolean }>`
  font-family: ${bodyFont};
  font-size: ${fonts.size.sm};
  font-weight: ${fonts.weight.medium};
  border: 1px solid ${({ $active }) => ($active ? colors.fontPrimary : colors.borderGrey)};
  background: ${({ $active }) => ($active ? colors.fontPrimary : colors.white)};
  color: ${({ $active }) => ($active ? colors.white : colors.fontPrimary)};
  border-radius: 999px;
  padding: 8px 18px;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;

  &:hover {
    background: ${({ $active }) => ($active ? colors.fontPrimary : colors.lighterGrey)};
  }
`;
